export default __webpack_public_path__ + "static/media/ngo-1.e2a10e3c.png";